import Service 			from "./../../Libs/Service";

let Tutorial = new Service({

	Name: "Tutorial",

	Events: {
		"Current User Loaded": function() {

			if (User.currentUser) {

			}

		}
	},

	Actions: {

	},

	init() {

		this.activeChapter = null;

		this.chapters = [
			{
				// По этому имени определяется прошёл уже пользователь этот этап обучения или нет
				name: "get-tag-code",
				title: "Get Tag Code",
				description: "<p>The creative in the Dashboard means one playable ad. It can have several versions with different settings, texts, images, etc... You can download mraid tag code for the specified version and then use this tag code to launch your ad campaign.</p><p>In this tutorial chapter we'll show you how to navigate between creatives, versions and how to receive tag code for the testing purposes.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Get Tag Code</b>\" training chapter and now you know where creatives and versions are located and how to publish creative and receive mraid tag code.</p><p>Note that publish to our server is strongly for the testing purposes. For the production you should to use Amazon S3 or another CDN services to store your creative files.</p>",
				video: "/tutorial/get-tag-code.mp4",
				// Определяем возможно ли выполнить этот этап обучения (может не быть нужных элементов в аккаунте пользователя)
				isPossible() {
					// Нужно наличие креатива плеебла (кнопка аплоада на сервере дашборда отображается всегда)
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				// События Дашборда на которые нужно проверять текущий шаг обучения
				trackEvents: ["Pseudo Modal Showed upload-dropdown", "Pseudo Modal Hided upload-dropdown", "Show UploadMraidio", "UploadMraidio Showed", "UploadMraidio Hided", "Mraidio Upload Progress Changed"],
				// Интервал времени через который дополнительно нужно проверять текущий шаг обучения
				trackInterval: 0,
				// Последовательность шагов обучения
				steps: [{
					// Название шага на которое могут ссылаться другие шаги обучения
					name: "projects-list",
					// Тип шага:
					// "information" -  Отображается с кнопкой, помечается завершённым по нажатию на эту кнопку и больше не показывается.
					// "navigation" -   Этот шаг будет повторяться если пользователь вернулся назад. Шаги этого типа группируются по значению свойства navigationFor.
					//                  Если шаг указанный в navigationFor не завершён и не доступны его элементы, то берётся первый с конца шаг типа navigation, элементы которого присутствуют на экране.
					// "action" - 	    Помечается завершённым по определённому событию дашборда указанному в свойстве actionEvent, которое должно запуститься пока этот шаг обучения активен.
					// "data" - 		Проверяет наличие данных или состояние системы через функцию dataChecker, чтобы это корректно работало - нужно хорошо продумать trackEvents и trackInterval.
					type: "information",
					// navigationFor: [], // Для типа шага "navigation" указывает имена шагов обучения к которым приведёт этот шаг навигации (возможно вместе с другими подобными шагами)
					// actionEvent: "", // Для типа шага "action" указывает событие дашборда которое приведёт к завешению этого шага если оно запустится пока этот шаг активен
					// dataChecker: () => {}, // Для типа шага "data" указывает функцию которая определит выполнен этот шаг обучения или нет (проверяет наличие нужных данных)
					// Текст надписи под стрелкой где описывается что нужно сделать пользователю
					text: "Creatives are displayed here, that is playables that you have",
					// Элемент который нужно подсветить
					highlightElement: ".app-body .page.preview > .creatives-plane.playables",
					// Тип подсветки элемента: "circle", "rectangle"
					highlightType: "rectangle",
					// Регулирование размера подсветки (для circle - одно число, для rectangle - 2 числа в массиве)
					highlightScale: [1, 1],
					// Элемент на который нужно указать стрелкой
					arrowElement: ".app-body .page.preview > .creatives-plane.playables .creative:not(.add)",
					// С какой стороны разместить стрелку "auto", "left", "left-top", "left-bottom", "right-top", "right-bottom"
					arrowPosition: "right-bottom",
					// Дополнительное смещение стрелки
					arrowOffset: [-30, -30],
					// Дополнительное смещение текста под кнопкой
					textOffset: [0, 0]
				}, {
					name: "versions-list",
					type: "information",
					text: "Here are displayed current creative versions",
					highlightElement: ".app-body .creative-versions",
					highlightType: "rectangle",
					highlightScale: [1, 1],
					arrowElement: ".app-body .page.preview > .creative-versions .creative-version-list .creative-version:first-child",
					arrowPosition: "right-bottom",
					arrowOffset: [0, 0]
				}, {
					name: "preview",
					type: "information",
					text: "Here is displayed preview of selected version of current creative",
					highlightElement: ".app-body .page.preview .preview-frame",
					highlightType: "rectangle",
					highlightScale: [1, 1],
					arrowElement: ".app-body .page.preview .preview-frame",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "upload-button",
					type: "navigation",
					navigationFor: ["start-upload"],
					text: "Press here to open publish options",
					highlightElement: ".app-body .controls .upload-button",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .upload-button",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "upload-to-dashboard",
					type: "navigation",
					navigationFor: ["start-upload"],
					text: "Choose this option to publish creative (for the testing purposes, not for production)",
					highlightElement: ".app-body .controls .upload-button .dropdown-menu",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.4],
					arrowElement: ".app-body .controls .upload-button .dropdown-menu .dropdown-item.mraidio",
					arrowPosition: "auto",
					arrowOffset: [35, -25]
				}, {
					name: "start-upload",
					type: "action",
					actionEvent: "Mraidio Upload Progress Starting",
					text: "Press here to publish your creative sources on our server",
					highlightElement: ".upload-mraid-io .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: ".upload-mraid-io .card .card-body .form-actions .btn.btn-primary.upload",
					arrowPosition: "auto",
					arrowOffset: [-20, 20]
				}, {
					name: "wait",
					type: "action",
					actionEvent: "Mraidio Upload Progress Finished",
					text: "Wait for the publishing process",
					highlightElement: ".upload-mraid-io .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: ".upload-mraid-io .card .card-body .processing .icon",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}, {
					name: "copy-code",
					type: "action",
					actionEvent: "Tag Code Copied",
					text: "Copy your tag code",
					highlightElement: ".upload-mraid-io .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: ".upload-mraid-io .card .card-body .form-actions .btn.btn-primary.copy",
					arrowPosition: "auto",
					arrowOffset: [-20, 20]
				}, {
					name: "close-window",
					type: "action",
					actionEvent: "UploadMraidio Hided",
					text: "Close this window",
					highlightElement: ".upload-mraid-io .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: ".upload-mraid-io .card .card-body .form-actions .btn.btn-dark.close-button",
					arrowPosition: "auto",
					arrowOffset: [20, 20]
				}]
			}, {
				name: "download-creative",
				title: "Download Creative",
				description: "<p>Some ad networks like Facebook, Unity Ads, etc. require playables to be bundled in custom formats rather than mraid tag codes. This may look like .zip file or .html file up to 5mb file size.</p><p>In this tutorial chapter we'll show you how to download your creative build for the various ad networks which require custom formats.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Download Creative</b>\" training chapter and now you know how to download custom playable builds like Facebook, Unity Ads, Mintegral and many more.</p>",
				video: "/tutorial/download-creative.mp4",
				isPossible: () => {
					// Нужно наличие креатива и версии (кнопка загрузки отображается всегда)
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["Pseudo Modal Showed download-dropdown", "Pseudo Modal Hided download-dropdown"],
				trackInterval: 0,
				steps: [{
					name: "download-button",
					type: "navigation",
					navigationFor: ["start-download"],
					text: "Press here to open download options",
					highlightElement: ".app-body .controls .download-button",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .download-button",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "start-download",
					type: "action",
					actionEvent: "Download Creative Started",
					text: "Choose one of custom formats to download creative",
					highlightElement: ".dropdown-menu.download-dropdown",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: ".dropdown-menu.download-dropdown > .networks",
					arrowPosition: "left",
					arrowOffset: [35, -25],
					textOffset: [-100, 0]
				}]
			}, {
				name: "target-url",
				title: "Target Url",
				description: "<p>One of the main setting of each creative is the \"target url\". This is url to which the user will be redirected when he click on the end card.</p><p>In this tutorial chapter we'll show you how to find and change target url for the different marketplaces.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Target Url</b>\" training chapter and now you know how to change target url.</p><p>You can place there clicks tracking url which will redirect to another url, for example.</p>",
				video: "/tutorial/target-url.mp4",
				isPossible: () => {
					// Нужно наличие креатива (настройка target-url есть всегда)
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
			
				trackEvents: ["Aside State Opened", "Aside State Closed", "Settings Tab Changed Next Tick"],
			
				trackInterval: 0,
			
				steps: [{
					name: "settings-button",
					type: "navigation",
					navigationFor: ["target-url-setting"],
					text: "Press here to open current version settings",
					highlightElement: ".app-body .controls .control-button.settings",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .control-button.settings",
					arrowPosition: "auto",
					arrowOffset: [25, -25],
					textOffset: [0, 0]
				}, {
					name: "main-settings-tab",
					type: "navigation",
					navigationFor: ["target-url-setting"],
					text: "Press here to open main settings",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .settings-content .nav-tabs i.main-tab",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .settings-content .nav-tabs i.main-tab",
					arrowPosition: "auto",
					arrowOffset: [5, -5]
				}, {
					name: "target-url-setting",
					type: "information",
					text: "Put your ios and android target urls here",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .settings-control.target-url",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .settings-control.target-url",
					arrowPosition: "left",
					arrowOffset: [-20, 0]
				}]
			}, {
				name: "tracking",
				title: "Tracking",
				description: "<p>Each our playable ad has events which indicates what happened in your creative. Starting with impression and loading, and ending with how many points the user has scored or how many clicks he did before redirect.</p><p>In this tutorial chapter we'll show you how to attach your tracking urls to the creative events.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Tracking</b>\" training chapter and now you know where to put your impression tracking url.</p><p>Also you can use all other events like Impression, Code Loaded, Assets Loaded, Creative Showed, etc. These events creates user activity funnel. After analyzing it, you will know at what stage more users are lost.</p><p>We can create any custom events for your playable ad upon request and you will have possibility to attach your tracking urls to these events as well.</p>",
				video: "/tutorial/tracking.mp4",
				isPossible: () => {
					// Нужно наличие креатива и версии (настройки трекинга должны быть всегда)
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["Aside State Opened", "Aside State Closed", "Settings Tab Changed Next Tick", "Selected Version Setting Changed:track-url-actions", "Selected Version Setting Changed:track-providers", "Settings Scroll"],
				trackInterval: 0,
				steps: [{
					name: "settings-button",
					type: "navigation",
					navigationFor: ["add-tracking-provider", "choose-event", "put-url"],
					text: "Press here to open current version settings",
					highlightElement: ".app-body .controls .control-button.settings",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .control-button.settings",
					arrowPosition: "auto",
					arrowOffset: [25, -25],
					textOffset: [0, 0]
				}, {
					name: "tracking-settings-tab",
					type: "navigation",
					navigationFor: ["add-tracking-provider", "choose-event", "put-url"],
					text: "Press here to open tracking settings",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.tracking-tab",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.tracking-tab",
					arrowPosition: "auto",
					arrowOffset: [5, -5]
				}, {
					name: "add-tracking-provider",
					type: "data",
					dataChecker: () => {
						return Settings.getVersionSettingValue(Version.SelectedVersion.id, "track-providers")?.["url-actions"]?.["enabled"];
					},
					text: "Add \"Track urls\" tracking provider",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-providers",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-providers .add-new-provider .custom-select",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}, {
					name: "scroll-settings-tab",
					type: "navigation",
					navigationFor: ["choose-event", "put-url"],
					text: "Scroll down to see \"Track urls\" setting",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-tracking .tab-content",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-tracking .tab-content",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "choose-event",
					type: "data",
					dataChecker: () => {
						return Settings.getVersionSettingValue(Version.SelectedVersion.id, "track-url-actions")?.["Impression"];
					},
					text: "Choose \"Impression\" event here",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-url-actions",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-url-actions .add-new-event .custom-select",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}, {
					name: "put-url",
					type: "information",
					text: "Put your impression tracking url here",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-url-actions",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .settings-control.track-url-actions .track-url-event.event-name-loader-initialized .track-url-event-urls input",
					arrowPosition: "auto",
					arrowOffset: [10, 20]
				}]
			}, {
				name: "localization",
				title: "Localization",
				description: "<p>You can change any text in your creative and create different texts for the different user locales. Also you can change text color, font and other styles.</p><p>In this tutorial chapter we'll show you how to change text and text styles.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Localization</b>\" training chapter and now you know where all texts located and how to change it.</p><p>If you haven't found the locale you need, you can request it from our managers.</p>",
				video: "/tutorial/localization.mp4",
				isPossible: () => {
					// Нужно наличие креатива и версии и текстов в текущей версии
					return Creative.getOrderedCreativesList(null, "playables").length > 0 && _.size(Localization.getVersionLocalization(Version.SelectedVersion)?.["en"]) > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["Aside State Opened", "Aside State Closed", "Settings Tab Changed Next Tick", "Localization Message Expanded", "Localization Message Collapsed"],
				trackInterval: 0,
				steps: [{
					name: "settings-button",
					type: "navigation",
					navigationFor: ["text-change", "style-change"],
					text: "Press here to open current version settings",
					highlightElement: ".app-body .controls .control-button.settings",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .control-button.settings",
					arrowPosition: "auto",
					arrowOffset: [25, -25],
					textOffset: [0, 0]
				}, {
					name: "localization-settings-tab",
					type: "navigation",
					navigationFor: ["text-change", "style-change"],
					text: "Press here to open localization settings",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.localization-tab",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.localization-tab",
					arrowPosition: "auto",
					arrowOffset: [5, -5]
				}, {
					name: "scroll-settings-tab",
					type: "navigation",
					navigationFor: ["text-change", "style-change"],
					text: "Scroll down to see messages",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "open-message",
					type: "navigation",
					navigationFor: ["text-change", "style-change"],
					text: "Press here to open message details",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area .messages .split-input:first-child",
					arrowPosition: "auto",
					arrowOffset: [10, -20]
				}, {
					name: "text-change",
					type: "information",
					text: "You can change text here...",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area .messages .split-input:first-child .text-controls.expanded textarea",
					arrowPosition: "auto",
					arrowOffset: [20, -20]
				}, {
					name: "style-change",
					type: "information",
					text: "...and styles here",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.1],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-localization .tab-content .messages-area .messages .split-input:first-child .text-controls.expanded .style-split-input:nth-child(3)",
					arrowPosition: "auto",
					arrowOffset: [20, 20]
				}]
			}, {
				name: "create-version",
				title: "Create Version",
				description: "<p>Depending on texts, sounds, gameplay speed and other settings, the playable may show different performance in production. Therefore, it would be a good idea to launch not just one version of the playable at once, but several. And after a short testing, leave one or few versions that gives more conversions.</p><p>In this tutorial chapter we'll show you how to create a new versions of the creative.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Create Version</b>\" training chapter and now you know how to create several versions in your playable creative.</p><p>Keep simple and understandable names for the versions. They will be added to publish folder name and in file name of the downloaded creative build.</p>",
				video: "/tutorial/duplicate-version.mp4",
				isPossible: () => {
					return Creative.getOrderedCreativesList(null, "playables").length > 0
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["VersionDuplicate Showed", "VersionDuplicate Hided", "Selected Version Switched", "VersionSettings Showed", "VersionSettings Hided", "VersionDelete Showed", "VersionDelete Hided"],
				trackInterval: 0,
				steps: [{
					name: "duplicate-version-button",
					type: "navigation",
					navigationFor: ["start-duplicate-version"],
					text: "Press here to open the duplicate version dialog",
					highlightElement: ".app-body .controls .control-button.duplicate-version",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .control-button.duplicate-version",
					arrowPosition: "auto",
					arrowOffset: [-25, -25],
					textOffset: [0, 0]
				}, {
					name: "start-duplicate-version",
					type: "action",
					actionEvent: "Selected Version Start Duplicating",
					text: "Press here to duplicate current creative version",
					highlightElement: ".creative-settings-actions-duplicate .form-actions .btn-primary",
					highlightType: "rectangle",
					highlightScale: [1.2, 1.5],
					arrowElement: ".creative-settings-actions-duplicate .form-actions .btn-primary",
					arrowPosition: "auto",
					arrowOffset: [-25, 25],
					textOffset: [0, 0]
				}, {
					name: "version-hover",
					type: "navigation",
					navigationFor: ["delete-version-confirm"],
					text: "Hover and press here to open version settings",
					highlightElement: ".creative-versions .creative-version-list .creative-version.custom:last-child .creative-version-edit-wrapper",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".creative-versions .creative-version-list .creative-version.custom:last-child .creative-version-edit-wrapper",
					arrowPosition: "auto",
					arrowOffset: [-25, 30],
					textOffset: [0, 0]
				}, {
					name: "start-delete-version",
					type: "navigation",
					navigationFor: "delete-version-confirm",
					text: "Press here to delete current version",
					highlightElement: ".version-settings .form-actions .delete-version-button",
					highlightType: "rectangle",
					highlightScale: [1.2, 1.5],
					arrowElement: ".version-settings .form-actions .delete-version-button",
					arrowPosition: "auto",
					arrowOffset: [-25, 25],
					textOffset: [0, 0]
				}, {
					name: "delete-version-confirm",
					type: "action",
					actionEvent: "Current Version Deleting",
					text: "Confirm delete current version",
					highlightElement: ".creative-settings-actions-delete .form-actions .btn-danger",
					highlightType: "rectangle",
					highlightScale: [1.2, 1.5],
					arrowElement: ".creative-settings-actions-delete .form-actions .btn-danger",
					arrowPosition: "auto",
					arrowOffset: [-25, 25],
					textOffset: [0, 0]
				}]
			}, {
				name: "assets-replace",
				title: "Assets Replace",
				description: "<p>When you get the idea to create a new version of your creative, you will probably want to change the background or the item or hero in your playable.</p><p>In this tutorial chapter we'll show you how to replace images and sounds in your playable.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Assets Replace</b>\" training chapter and now you know how to replace a playable asset with new one.</p><p>Note that new image should be the same size like replaced, otherwise, the image will appear larger or smaller on the screen. In order to find out the size of the image to be replaced, you can download it.</p>",
				video: "/tutorial/asset-replace.mp4",
				isPossible: () => {
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["Aside State Opened", "Aside State Closed", "Settings Tab Changed Next Tick", "Settings Scroll"],
				trackInterval: 0,
				steps: [{
					name: "settings-button",
					type: "navigation",
					navigationFor: ["download-button", "replace-button"],
					text: "Press here to open current version settings",
					highlightElement: ".app-body .controls .control-button.settings",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .control-button.settings",
					arrowPosition: "auto",
					arrowOffset: [25, -25],
					textOffset: [0, 0]
				}, {
					name: "assets-settings-tab",
					type: "navigation",
					navigationFor: ["download-button", "replace-button"],
					text: "Press here to open assets settings",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.assets-tab",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .nav-tabs i.assets-tab",
					arrowPosition: "auto",
					arrowOffset: [5, -5]
				}, {
					name: "scroll-settings-tab",
					type: "navigation",
					navigationFor: ["download-button", "replace-button"],
					text: "Scroll down to see \"background.jpg\" asset",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content",
					highlightType: "circle",
					highlightScale: 5,
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "download-button",
					type: "information",
					text: "This is download asset button",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content .version-assets-settings .asset-type.image .assets-list .assets-list-item:first-child .asset-list-edit .asset-list-edit-download",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content .version-assets-settings .asset-type.image .assets-list .assets-list-item:first-child .asset-list-edit .asset-list-edit-download",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}, {
					name: "replace-button",
					type: "information",
					text: "This is replace asset button",
					highlightElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content .version-assets-settings .asset-type.image .assets-list .assets-list-item:first-child .asset-list-edit .asset-list-edit-replace",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: "body.aside-menu-show .app-body .aside-menu .tabs.settings-content.tab-assets .tab-content .version-assets-settings .asset-type.image .assets-list .assets-list-item:first-child .asset-list-edit .asset-list-edit-replace",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}]
			}, {
				name: "preview",
				title: "Public preview link",
				description: "<p>If you want to show your playable or a new version changed by yourself to your team or customer, you can create a public preview link. The creative version remains in the same state as it was at the time the preview was created.</p><p>In this tutorial chapter we'll show you how to create public preview link.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Public preview link</b>\" training chapter and now you know how to show your creative to your team.</p><p>Note that you also can invite any count of users in the Dashboard on the Company Users page, if you is admin (first user of the account).</p>",
				video: "/tutorial/create-preview.mp4",
				isPossible: () => {
					// Нужно наличие креатива и версии
					return Creative.getOrderedCreativesList(null, "playables").length > 0;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				onComplete() {
					Broadcast.call("Hide PreviewList");
				},
				trackEvents: ["PreviewCreate Showed", "PreviewCreate Hided", "PreviewList Showed", "PreviewList Hided", "New Preview Creating Completed"],
				trackInterval: 0,
				steps: [{
					name: "preview-button",
					type: "navigation",
					navigationFor: ["start-create-preview", "copy-link"],
					text: "Press here to open public preview window",
					highlightElement: ".app-body .controls .public-preview",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-body .controls .public-preview",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "create-new-preview",
					type: "navigation",
					navigationFor: ["start-create-preview"],
					text: "Press here to create a new preview",
					highlightElement: ".creative-version-preview-list .form-actions .btn-primary",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".creative-version-preview-list .form-actions .btn-primary",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}, {
					name: "start-create-preview",
					type: "action",
					actionEvent: "New Preview Creating",
					text: "Press here to create a new preview",
					highlightElement: ".creative-version-preview-create .form-actions .btn-primary",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".creative-version-preview-create .form-actions .btn-primary",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}, {
					name: "wait",
					type: "action",
					actionEvent: "New Preview Creating Completed",
					text: "Wait for the preview creation process",
					highlightElement: ".creative-version-preview-create .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.2],
					arrowElement: ".creative-version-preview-create .card",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "copy-link",
					type: "action",
					actionEvent: "Preview Link Pressed",
					text: "Press here to open your preview",
					highlightElement: ".creative-version-preview-list .existing-previews .existing-preview:first-child .link",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.2],
					arrowElement: ".creative-version-preview-list .existing-previews .existing-preview:first-child .link", // Если писать :last-child то нужно учитывать прокрутку и не внутри экрана а внутри кастомного элемента что ещё больше усложнит логику кода обучения
					arrowPosition: "auto",
					arrowOffset: [15, -20]
				}]
			}, {
				name: "amazon",
				title: "Amazon S3 CDN",
				description: "<p>As we mentioned before, for the production use of creatives, in case when creative assets stored separately from tag code (mraid release), you should publish / upload your creative to the CDN (Content Delivery Network) like Amazon S3.</p><p>In this tutorial chapter we'll show you how to integrate our Dashboard with your Amazon CDN, automatize publishing to CDN and receive production ready tag code.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Amazon S3 CDN</b>\" training chapter and now you know how to automatize publishing to Amazon S3.</p><p>Note that publishing to CDN will increase playable loading speed for the end users and increase your ad campaign productivity.</p>",
				video: "/tutorial/amazon-s3.mp4",
				isPossible: () => {
					return User.currentUser && (User.currentUser.Tags['publisher-admin'] || User.currentUser.isAdmin) && Publisher.SelectedPublisher;
				},
				onStart() {

				},
				trackEvents: ["Pseudo Modal Showed account-dropdown", "Pseudo Modal Hided account-dropdown", "Layout Page Changed Next Tick", "Account Settings Dropdown Scroll"],
				trackInterval: 0,
				steps: [{
					name: "account-button",
					type: "navigation",
					navigationFor: ["amazon-s3-settings"],
					text: "Press here to open settings dropdown",
					highlightElement: ".app-header .right-controls .account-button",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-header .right-controls .account-button",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "scroll-to-company-settings",
					type: "navigation",
					navigationFor: ["amazon-s3-settings"],
					text: "Scroll down to see \"Company settings\"",
					highlightElement: ".app-header .right-controls .account-button .dropdown-menu",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".app-header .right-controls .account-button .dropdown-menu",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "open-company-settings",
					type: "navigation",
					navigationFor: ["amazon-s3-settings"],
					text: "Press here to open company settings",
					highlightElement: ".app-header .right-controls .account-button .dropdown-menu .publisher li.company-settings",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".app-header .right-controls .account-button .dropdown-menu .publisher li.company-settings",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}, {
					name: "amazon-s3-settings",
					type: "information",
					text: "Put your Amazon S3 credentials here",
					highlightElement: ".page.publisher-settings .publisher-settings .settings-section.amazon-s3",
					highlightType: "rectangle",
					highlightScale: [1, 1],
					arrowElement: ".page.publisher-settings .publisher-settings .settings-section.amazon-s3",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}]
			}, {
				name: "invite",
				title: "Invite users",
				description: "<p>If you have colleagues who also work with playables in your team you can invite it into our Dashboard and work together here.</p><p>In this tutorial chapter we'll show you how to add new users.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Invite users</b>\" training chapter and now you can add more users to your account.</p><p>After creation invitation link you should send it to your colleague and he will be able to sign into your account.</p><p>We do not charge any fees for new users, as well as for new creative versions created by you.</p>",
				video: "/tutorial/invite-users.mp4",
				isPossible: () => {
					return true;
				},
				onComplete() {
					Broadcast.call("Hide AddUser");
				},
				trackEvents: ["Pseudo Modal Showed account-dropdown", "Pseudo Modal Hided account-dropdown", "Layout Page Changed Next Tick", "Account Settings Dropdown Scroll", "AddUser Showed", "AddUser Hided"],
				trackInterval: 0,
				steps: [{
					name: "account-button",
					type: "navigation",
					navigationFor: ["invite-button"],
					text: "Press here to open settings dropdown",
					highlightElement: ".app-header .right-controls .account-button",
					highlightType: "circle",
					highlightScale: 1,
					arrowElement: ".app-header .right-controls .account-button",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "scroll-to-company-users",
					type: "navigation",
					navigationFor: ["invite-button"],
					text: "Scroll down to see \"Users\"",
					highlightElement: ".app-header .right-controls .account-button .dropdown-menu",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".app-header .right-controls .account-button .dropdown-menu",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "open-company-settings",
					type: "navigation",
					navigationFor: ["invite-button"],
					text: "Press here to open company users page",
					highlightElement: ".app-header .right-controls .account-button .dropdown-menu .publisher li.company-users",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".app-header .right-controls .account-button .dropdown-menu .publisher li.company-users",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}, {
					name: "open-invite-dialog",
					type: "navigation",
					navigationFor: ["invite-button"],
					text: "Press here to open invite user popup",
					highlightElement: ".page.publisher-users .header-controls .buttons .btn-primary",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".page.publisher-users .header-controls .buttons .btn-primary",
					arrowPosition: "auto",
					arrowOffset: [15, -25]
				}, {
					name: "invite-button",
					type: "information",
					text: "Type the name of new user and then copy invitation link",
					highlightElement: ".user-add .card",
					highlightType: "rectangle",
					highlightScale: [1, 1],
					arrowElement: ".user-add .card .form-horizontal",
					arrowPosition: "auto",
					arrowOffset: [-25, 25]
				}]
			}, {
				name: "create-project",
				title: "Create Creative from Template",
				description: "<p>We have several simple creative templates that you can use for free, including production use.</p><p>In this tutorial chapter we'll show you how to create new creative from template.</p>",
				finishText: "<h5>Congratulations!</h5><p>You have successfully completed the \"<b>Create Creative from Template</b>\" training chapter and now you know how to create it.</p><p>Any comments and suggestions regarding free templates are welcome. If you need any complex changes, we will be happy to help you for an additional fee.</p>",
				video: "/tutorial/create-project-from-template.mp4",
				isPossible: () => {
					return true;
				},
				onStart() {
					if (Layout.page !== "playables") Layout.setPage("playables");
				},
				trackEvents: ["PlayableCreate Showed", "PlayableCreate Hided", "PlayableCreateFromTemplate Showed", "PlayableCreateFromTemplate Hided", "Selected Playable Template Changed", "Creatives Plane Scroll"],
				trackInterval: 0,
				steps: [{
					name: "add-project-button",
					type: "navigation",
					navigationFor: ["add-project"],
					text: "Scroll down to see Add Creative button",
					highlightElement: ".app-body .creatives-plane.playables",
					highlightType: "rectangle",
					highlightScale: [1, 1],
					arrowElement: ".app-body .creatives-plane.playables",
					arrowPosition: "right",
					arrowOffset: [-20, 0],
					textOffset: [150, 0]
				}, {
					name: "add-project-button",
					type: "navigation",
					navigationFor: ["add-project"],
					text: "Press here to open creative creation options",
					highlightElement: ".creatives-plane .creative-add-icon .fa.fa-plus",
					highlightType: "circle",
					highlightScale: 3,
					arrowElement: ".creatives-plane .creative-add-icon .fa.fa-plus",
					arrowPosition: "auto",
					arrowOffset: [25, -25]
				}, {
					name: "choose-create-from-template",
					type: "navigation",
					navigationFor: ["add-project"],
					text: "Press here to open templates list",
					highlightElement: ".creative-create .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".creative-create .card .form-horizontal button.btn-primary",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "choose-template",
					type: "navigation",
					navigationFor: ["add-project"],
					text: "Press here to choose template",
					highlightElement: ".creative-create-playable-from-template .card",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".creative-create-playable-from-template .card .playables .playable-container:first-child",
					arrowPosition: "left",
					arrowOffset: [0, 0]
				}, {
					name: "add-project",
					type: "action",
					actionEvent: "Playable From Template Creating",
					text: "Press here to create new creative from template",
					highlightElement: ".creative-create-playable-from-template .card .form-actions .btn-primary.enabled",
					highlightType: "rectangle",
					highlightScale: [1.1, 1.5],
					arrowElement: ".creative-create-playable-from-template .card .form-actions .btn-primary.enabled",
					arrowPosition: "auto",
					arrowOffset: [0, 0]
				}]
			}
		];

	},

	getActiveChaptersCount() {

		return _.size(_.filter(this.chapters, chapter => this.isChapterReady(chapter)));

	},

	isChapterReady(chapter) {

		return chapter.isPossible() && !User.currentUser?.options?.features?.["tutorial-chapters"]?.[chapter.name];

	},

	isChapterCompleted(chapter) {

		return !User.currentUser?.options?.features?.["tutorial-chapters"]?.[chapter.name];

	},

	getFirstReadyChapterIndex(fromIndex = 0) {

		return _.findIndex(this.chapters, chapter => this.isChapterReady(chapter), fromIndex);

	},

	skipAllExistChapters() {

		if (!User.currentUser.options.features) User.currentUser.options.features = {};
		if (!User.currentUser.options.features["tutorial-chapters"]) User.currentUser.options.features["tutorial-chapters"] = {};

		_.each(this.chapters, chapter => {

			User.currentUser.options.features["tutorial-chapters"][chapter.name] = true;

		});

		User.toggleFeature(User.currentUser.id, "tutorial-chapters", User.currentUser.options.features["tutorial-chapters"]);

		// Набор активных (не пройденных) глав изменился: сообщаем компонентам,
		// чтобы они перерисовали счётчик обучения (TutorialButton)
		Broadcast.call("Tutorial Chapters Changed");

	},

	startChapter(tutorialChapter) {

		this.activeChapter = tutorialChapter;

		Broadcast.call("Tutorial Active Chapter Changed");

		// Проходим с начала и помечаем все шаги как невыполненные
		for (let i=0, l=this.activeChapter.steps.length; i<l; i++) {

			let step = this.activeChapter.steps[i];

			step.completed = false;

		}

		this.findActiveChapterStep();

		if (this.activeChapter.trackEvents) {

			_.each(this.activeChapter.trackEvents, trackEvent => {

				Broadcast.on(trackEvent, () => {

					this.findActiveChapterStep();

				}, "tutorial");

			});

		}

		if (this.activeChapter.trackInterval) {

			clearInterval(this.trackInterval);
			this.trackInterval = setInterval(() => {

				this.findActiveChapterStep();

			}, this.activeChapter.trackInterval);

		}

		if (tutorialChapter.onStart) tutorialChapter.onStart();

	},

	cancelChapter() {

		if (this.activeChapter) {

			this.clearChapter();

			Broadcast.call("Tutorial Active Chapter Changed");

			clearInterval(this.trackInterval);

		}

	},

	completeChapter() {

		if (this.activeChapter) {

			if (!User.currentUser.options.features) User.currentUser.options.features = {};
			if (!User.currentUser.options.features["tutorial-chapters"]) User.currentUser.options.features["tutorial-chapters"] = {};
			User.currentUser.options.features["tutorial-chapters"][this.activeChapter.name] = true;

			User.toggleFeature(User.currentUser.id, "tutorial-chapters", User.currentUser.options.features["tutorial-chapters"]);

			this.clearChapter();

			Broadcast.call("Tutorial Chapter Completed");

			// Глава отмечена пройденной - обновляем и счётчик активных глав обучения
			Broadcast.call("Tutorial Chapters Changed");

		}

	},

	clearChapter() {

		if (this.activeChapterStep?.actionEvent) Broadcast.off(this.activeChapterStep.actionEvent, "tutorial");
		if (this.activeChapter?.trackInterval) clearInterval(this.trackInterval);

		if (this.activeChapter.trackEvents) {

			_.each(this.activeChapter.trackEvents, trackEvent => {

				Broadcast.off(trackEvent, "tutorial");

			});

		}

		if (this.activeChapter.onComplete) this.activeChapter.onComplete();

		this.activeChapter = null;
		this.activeChapterStep = null;
		this.activeChapterStepIndex = null;

	},

	findActiveChapterStep() {

		let nextStepIndex = this.getNextActiveChapterStepIndex();

		//console.log('findActiveChapterStep', nextStepIndex);

		if (nextStepIndex === null) {

			this.completeChapter();

		} else {

			// Пытаемся показать этот шаг. Но чтобы его совершить возможно понадобится открыть какие-то окна или настройки или перейти на другой экран
			let targetStep = this.activeChapter.steps[nextStepIndex];

			//console.log('findActiveChapterStep', targetStep.name);

			// Ищем среди целевого шага и шагов которые к нему ведут нужные DOM элементы туториала начиная с конца и устанавливаем первый у котрого нашлись оба элемента
			for (let i=this.activeChapter.steps.length-1; i>=0; i--) {

				let step = this.activeChapter.steps[i];

				if (step.name === targetStep.name || (step.type === "navigation" && _.includes(step.navigationFor, targetStep.name))) {

					let els = [document.querySelector(step.arrowElement), document.querySelector(step.highlightElement)],
						rects = [els[0]?.getBoundingClientRect(), els[1]?.getBoundingClientRect()];

					console.log('step.name', step.name, rects[0]?.width, rects[1]?.width, els, rects);

					// Определяем что элемент есть на странице и видимый (без display none у него или его родителя и внутри видимой части документа)
					if (els[0] && els[1] && rects[0].width > 0 && rects[1].width > 0 && rects[0].top + rects[0].height / 2 < window.innerHeight && rects[0].top + rects[0].height / 2 > 0) {

						nextStepIndex = i;

						break;

					}

				}

			}

			console.log('nextStepIndex', nextStepIndex);

			if (this.activeChapterStepIndex !== nextStepIndex) this.setActiveChapterStepByIndex(nextStepIndex);

		}

	},

	setActiveChapterStepByIndex(index) {

		this.activeChapterStepIndex = index;

		let oldChapterStep = this.activeChapterStep;
		let newChapterStep = this.activeChapterStep = this.activeChapter.steps[this.activeChapterStepIndex];

		if (oldChapterStep) {

			if (oldChapterStep.actionEvent) {

				Broadcast.off(oldChapterStep.actionEvent, "tutorial");

			}

		}

		if (newChapterStep) {

			if (newChapterStep.actionEvent) {

				Broadcast.once(newChapterStep.actionEvent, () => {

					this.completeStep();

				}, "tutorial");

			}

		}

		Broadcast.call("Tutorial Active Chapter Step Changed");

	},

	completeStep() {

		this.activeChapterStep.completed = true;

		this.findActiveChapterStep()

	},

	getNextActiveChapterStepIndex() {

		for (let i=0, l=this.activeChapter.steps.length; i<l; i++) {

			let step = this.activeChapter.steps[i];

			this.checkStepCompleted(step);

			if (!step.completed && (step.type === "information" || step.type === "action" || step.type === "data")) return i;

		}

		return null;

	},

	checkStepCompleted(step) {

		if (step.type === "data") {

			step.completed = step.dataChecker();

		}

	}

});

window.Tutorial = Tutorial;

export { Tutorial }
